/* RESPONSIBLE TEAM: team-phone */

export const FIN_VOICE_NO_CONFIG_ERROR =
  'operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.error.no-configuration';

export const FIN_VOICE_NO_CONFIG_ERROR_WITH_KEY =
  'operator.fin.setup.tabs.setup-and-go-live.phone.handover-escalation.error.no-configuration-with-key';
